export default __webpack_public_path__ + "static/media/image_4.7665a3d1.png";